import { clearLTAppointments } from './appointmentsSlice'
import { clearSelectedClientId } from './ltClientSlice'
import { clearSelectedAssignmentId } from '../../../assignments/data/assignmentsSlice'
import { clearSelectedConversation } from '../../../messages/data/messagesSlice'

export const clearSelectedClientStore = () => {
  return (dispatch: any) => {
    dispatch(clearSelectedClientId())
    dispatch(clearLTAppointments())
    dispatch(clearSelectedAssignmentId())
    dispatch(clearSelectedConversation())
  }
}
